"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMedicalAssistantApiResponseSchema = void 0;
const zod_1 = require("zod");
const address_schema_1 = require("../global/address.schema");
const api_1 = require("../global/api");
const enums_1 = require("./enums");
exports.getMedicalAssistantApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('medical-assistants'),
        attributes: zod_1.z.object({
            firstname: zod_1.z.string(),
            lastname: zod_1.z.string(),
            email: zod_1.z.string(),
            phone: zod_1.z.string().nullable().default(null),
            contractType: enums_1.contractTypeSchema,
            weeklyHours: zod_1.z.number().int(),
            hireDate: zod_1.z.coerce.date(),
            dateOfBirth: zod_1.z.coerce.date().nullable().default(null),
            birthPlace: zod_1.z.string().nullable().default(null),
            nationality: zod_1.z.string().nullable().default(null),
            // Deliberately permissive on read: the column is nullable and only
            // backfilled over time, so a legacy value must never break the page.
            // The format is enforced on write (payload schema + API DTO).
            socialSecurityNumber: zod_1.z.string().nullable().default(null),
            // Optional, not defaulted: the admin routes always send them, while
            // PATCH /assistants/me omits them entirely so an assistant never
            // receives employer-held payroll data about herself.
            hasSupplementaryHealthInsurance: zod_1.z.boolean().optional(),
            hasTransportAllowance: zod_1.z.boolean().optional(),
            address: address_schema_1.assistantAddressSchema.nullable().default(null),
            deactivated: zod_1.z.boolean(),
            // stat-card aggregate — placeholder until 496C supplies absence data
            paidLeaveDaysTaken: zod_1.z.number().nullable().default(null),
            // accessible offices
            offices: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string().uuid(), name: zod_1.z.string() })),
        }),
    }),
});
